import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import type { AppDispatch, RootState } from 'store';

import { Scaffold } from 'layouts';
import { Paginator, ListingPageHeader, SettingsMenu } from 'components/Shared';

import {
    EmailLogFilters,
  EmailLogList,
} from 'components/Pages/AlertEmailLog';

import { PaginateAlertEmailLogsActions as PaginateActions } from 'store/ducks/alertEmailLogs';

import { usePaginationCache } from 'hooks';
import * as S from './styles';

export const EmailLogListPage: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();

  const { paginationCache, updatePaginationCache, handleSort } =
    usePaginationCache('alertEmailLogs');

  const { data, pagination, loading } = useSelector(
  (state: RootState) => state.paginateAlertEmailLogs
  );

  const [query, setQuery] = useState<EmailLogFilters>({
    search: '',
    page: 1,
    limit: 10,
    ...paginationCache,
  });

  const onPageChange = useCallback((page: number): void => {
    setQuery((state: any) => ({ ...state, page }));
  }, []);

  const handleFilter = (filters: EmailLogFilters) => {
  setQuery((prev) => ({
    ...prev,
    ...filters,
    page: 1,
  }));
};

  useEffect(() => {
    dispatch(PaginateActions.request(query));
  }, [dispatch, query]);

  useEffect(() => {
    return () => {
      dispatch(PaginateActions.reset());
      updatePaginationCache(query);
    };
  }, [dispatch, query, updatePaginationCache]);

  return (
    <Scaffold>
      <SettingsMenu />
      <S.MainPanel>
        <ListingPageHeader
          icon={<S.EmailIcon />}
          title="Histórico de Alertas"
          isLoading={loading}
        />
        <EmailLogFilters
          onFilter={handleFilter}
        />
        <EmailLogList
          alerts={data}
          currentSort={query}
          onSort={(sort) => handleSort(query, sort, setQuery)}
        />

        <Paginator onPageChange={onPageChange} pagination={pagination} />
      </S.MainPanel>
    </Scaffold>
  );
};